import { Injectable, inject } from '@angular/core';
import { AggregationKey } from '../../../model/aggregations';
import { orderedUnterrichtszeit } from '../../../model/lernformen';
import { FacettenService } from '../facetten.service';
import { UnterrichtszeitUrlService } from './unterrichtszeiturl.service';

@Injectable({
  providedIn: 'root'
})
export class UnterrichtszeitService extends FacettenService {
  constructor() {
    const urlService = inject(UnterrichtszeitUrlService);

    super(urlService, AggregationKey.Unterrichtszeit, orderedUnterrichtszeit);
  }
}
